module.exports = __webpack_public_path__ + "img/hero.26307c3e.png";